export const POLLING_TIME = 100;
